var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollections(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 16.498H0.5V5.24805H18.5V16.498ZM2 14.998H17V6.74805H2V14.998Z",
    fill: "#0B0500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0005 5.24805H15.5005V4.49805H3.50049V5.24805H2.00049V2.99805H17.0005V5.24805Z",
    fill: "#0B0500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5044 2.99805H14.0044V2.24805H5.00439V2.99805H3.50439V0.748047H15.5044V2.99805Z",
    fill: "#0B0500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7529 10.1226H4.25293V11.6226H14.7529V10.1226Z",
    fill: "#0B0500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollections);
export default __webpack_public_path__ + "static/media/collections.8a865792.svg";
export { ForwardRef as ReactComponent };